module.exports = __webpack_public_path__ + "img/51mo-20419462.e4f21f89.png";